/* eslint-disable max-len */
import React from "react"
import Pagination from "../../../../components/Pagination"
import { formatAdjustedDate, formatDateTime } from "../../../../CommonMethods/formatDate"

const TransactionTable = ({TransactionList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    formatMMDDate,
    TransactionCount}) => {
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    return(
        <div class=" w-full relative">
            <div class=" overflow-x-auto pb-2.5 scroll-bar -mx-[2px]">
                <div class={`flex px-[6px] ${TransactionCount > 50 ? 'max-h-[calc(100vh-268px)]' : 'max-h-[calc(100vh-180px)]'}`}>
                    <table aria-label="Outside Table" class="w-full relative stickyhead" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[10%]">
                                    <span class="sticky top-0 flex items-center justify-start">Date</span>
                                </th>
                                <th class="w-[15%]">
                                    <span class="sticky top-0 flex items-center justify-start">Added Date</span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="sticky top-0 flex items-center justify-start">Particulars</span>
                                </th>
                                <th class="w-[12%]">
                                    <span class="sticky top-0 flex items-center justify-start">Reference #</span>
                                </th>
                                <th class="w-[10%]">
                                    <span class="sticky top-0 flex items-center justify-start">Type</span>
                                </th>
                                <th class="w-[10%]">
                                    <span class="sticky top-0 flex items-center justify-end">Debit</span>
                                </th>
                                <th class="w-[10%]">
                                    <span class="sticky top-0 flex items-center justify-end">Credit</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody >
                            {(searchParams.get('main_group') === 'Assets' || searchParams.get('main_group') === 'Liabilities') &&<tr class="group">
                                <td class="text-start" id={'opening_balance_date'}>{formatMMDDate(TransactionList?.start_date)}</td>
                                <td class="text-start" id={'opening_balance_date'}>-</td>
                                <td colSpan={3} class="text-start">Opening Balance</td>
                                <td class="text-end " id={'opening_balance_debit'}>{TransactionList?.opening_balance_type === 'dr' ? Math.abs(parseFloat(TransactionList?.opening_balance_amount)).toFixed(2) : '0.00'}</td>
                                <td class="text-end min-w-[105px]" id={'opening_balance_credit'}>{TransactionList?.opening_balance_type === 'cr' ? Math.abs(parseFloat(TransactionList?.opening_balance_amount)).toFixed(2) : '0.00'}</td>
                            </tr>}
                            {TransactionList?.line_item?.map((transaction, index) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class={`group`} id={index+'transaction'} key={index+'transaction'}>
                                        <td class="text-start" id={'transaction_date' + index}>{formatAdjustedDate(transaction?.date) || '-'}</td>
                                        <td class="text-start" id={'opening_balance_date'}>{formatDateTime(transaction?.particular_ledger_created_at)}</td>
                                        <td class="text-start" id={'particular_ledger_name'+index}>{transaction?.particular_ledger_name || '-'}</td>

                                        <td class="text-start" id={'reference_number'+index}>{transaction?.reference_number || '-'}</td>
                                        <td class="text-start  capitalize" id={'reference_type'+index}>{transaction?.reference_type === 'grn-entry' ? 'GRN' : transaction?.reference_type|| '-'}</td>
                                        
                                        <td class="text-end" id={'debit'+index}>{transaction?.amount_type === 'dr' ? Math.abs(parseFloat(transaction?.amount)).toFixed(2) : '0.00'}</td>
                                        <td class="text-end"  id={'credit'+index}>{transaction?.amount_type === 'cr' ? Math.abs(parseFloat(transaction?.amount)).toFixed(2) : '0.00'}</td>
                                    </tr>
                                </>))}
                            
                            <tr class="group">
                                <td class="text-start" id={'closing_balance_date'}>{formatMMDDate(TransactionList?.end_date)}</td>
                                <td class="text-start" id={'opening_balance_date'}>-</td>
                                <td colSpan={3} class="text-start ">Closing Balance</td>
                                <td class="text-end " id={'closing_balance_debit'}>{TransactionList?.closing_balance_type === 'dr' ? Math.abs(parseFloat(TransactionList?.closing_balance_amount)).toFixed(2) : '0.00'}</td>
                                <td class="text-end  min-w-[105px]" id={'closing_balance_credit'}>{TransactionList?.closing_balance_type === 'cr' ? Math.abs(parseFloat(TransactionList?.closing_balance_amount)).toFixed(2) : '0.00'}</td>
                            </tr> 
                            
                            <tr class="group">
                                <td colSpan={4} class="text-start font-semibold" id={'Total'}>Total</td>
                                <td class="text-end  font-semibold" id={'grand_total_debit'}>{Math.abs(parseFloat(TransactionList?.grand_total_dr)).toFixed(2) || '0.00'}</td>
                                <td class="text-end  min-w-[105px] font-semibold" id={'grand_total_credit'}>{Math.abs(parseFloat(TransactionList?.grand_total_cr)).toFixed(2) || '0.00'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="">
                {TransactionCount > 50 && <Pagination
                    TotalCount={TransactionCount}
                    limit={50}
                    totalPageNumber={Math?.ceil(TransactionCount / 50)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div>
        </div>
    )
}


export default TransactionTable;